import { ReactNode } from "react";
import styles from "@/pages/index.module.css";
import { articles } from "@/utils/news";
import { NewsArticle } from "@/components/NewsArticle";
import { Link } from "react-router";

export function News(): ReactNode {
  const article = articles[0];

  return (
    <div className={styles.newsContainer}>
      <h1 className={styles.newsHeader}>Latest News</h1>
      <div className={`${styles.newsArticles} ${styles.newsArticlesPanel}`}>
        <NewsArticle article={article} />
        <hr />
        <p className={styles.newsPreviousNews}>
          <Link to="/news">Previous news ➜</Link>
        </p>
      </div>
    </div>
  );
}
